import { useEffect } from 'react'

export const useMapZoomLimits = ({ map, mapLoaded, isAdmin, cityZoom }) => {
  useEffect(() => {
    if (!map || !mapLoaded) return

    if (isAdmin) {
      map.setMinZoom(3)
      map.setMaxZoom(22)
    } else {
      // Use canton's calculated zoom minus 2 levels as minZoom so the user
      // can zoom out slightly beyond the canton view without going to world view
      const minZoom = cityZoom ? Math.max(1, cityZoom - 2) : 8
      map.setMinZoom(minZoom)
      map.setMaxZoom(22)
    }
  }, [map, mapLoaded, isAdmin, cityZoom])
}
